import { deleteBookmarkApi, getBookmarksApi, postBookmarkApi } from "@/apis/bookmark";
import { DeleteApiClient, GetApiClient, PostApiClient } from "@/utils/api-client";
import { DataSchema } from "common";

export class BookmarkUsecase {
  static bookmarks(apiClient: GetApiClient) {
    return getBookmarksApi(apiClient);
  }

  static addBookmark(apiClient: PostApiClient, data: DataSchema.Bookmark) {
    return postBookmarkApi(apiClient, data);
  }

  static deleteBookmark(apiClient: DeleteApiClient, documentId: string, pageNo: number) {
    return deleteBookmarkApi(apiClient, documentId, pageNo);
  }
}
